import { Component } from '@angular/core';

@Component({
  selector: 'ciao-check-out-icon',
  imports: [],
  templateUrl: './check-out-icon.component.html',
})
export class CheckOutIconComponent {}
